import React, { Component, Fragment } from "react";
import { BottomScrollListener } from "react-bottom-scroll-listener";
import { connect } from "react-redux";
import cloneDeep from "lodash.clonedeep";
import * as actionTypes from "../../../../store/Actions/actions";
import Spinner from "../../../../assets/images/spinner.gif";
import * as UTILS from "../../../../utils/Utils";
import "../Library.scss";
import noImage from "../../../../assets/images/noImage.png";
import Axios from "../../../../axios";
let userID;
let sessionID;

class ImagesContent extends Component {
  _isMounted = false;
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
    this.state = {
      loader: false,
      note: false,
      initialItems: [],
      searchString: "",
      filter: "d",
      initP: 0,
      chosenImage: { image_id: null },
      elementID: null,
      noImageList: false,
      reloadVideos: false,
      savingData: null,
    };
  }
  componentDidMount = () => {
    this.setState({
      elementID: this.props.ID,
    });

    this.fetchImages(
      this.state.filter,
      this.state.initP,
      this.state.searchString
    );

    this.refs.search.focus();
  };
  componentDidUpdate() {
    if (this.props.reloadAPI == true) {
      this.setState(
        {
          ...this.state,
          initP: 0,
        },
        this.fetchImages(this.state.filter, 0, this.state.searchString)
      );

      this.props.reloadAPICall(false);
    }
  }

  handleChange(e) {
    this.setState(
      {
        ...this.state,
        searchString: e.target.value,
        initP: 0,
      },
      () => {
        if (e.target.value == "") {
          this.setState(
            {
              ...this.state,
              noImageList: false,
            },
            this.fetchImages(
              this.state.filter,
              this.state.initP,
              this.state.searchString
            )
          );
        }
      }
    );
  }
  pushImage = (image) => {
    const layout = cloneDeep(this.props.layout);

    const newLayout = UTILS.UpdateLayout(
      layout,
      this.props.ID,
      (item) => {
        item.src = image.image_thumb ? image.image_thumb : "";
        item.srcID = image.image_id ? image.image_id : "";
      },
      (colItem) => {
        colItem.src = image.image_thumb ? image.image_thumb : "";
        colItem.srcID = image.image_id ? image.image_id : "";
      },
      (colItemNested) => {
        colItemNested.src = image.image_thumb ? image.image_thumb : "";
        colItemNested.srcID = image.image_id ? image.image_id : "";
      }
    );
    // files.length > 0 ? this.props.layoutArray(this.props.layoutTitle, newLayout):null;
    this.props.layoutArray(this.props.layoutTitle, newLayout);
  };
  fetchImages = (filter, initP, searchString) => {
    userID = this.props.userID;
    sessionID = this.props.sessionID;

    this.setState({
      loader: true,
      elementID: this.props.ID,
    });
    const self = this;

    Axios.MediaService.GET_IMAGES(userID, sessionID, filter, initP, searchString)
      .then((response) => {
        const data = response.data.body;

        if (response.data.statusCode === "success") {
          if (data.length == 12) {
            self.setState({
              ...this.state,
              initialItems: data,
              loader: false,
              
            });
          }

          if (data.length < 12) {
            this.setState({
              ...this.state,
              loader: false,
              noImageList: true,
              initialItems: data,
            });
          }
        }
      })
      .catch(function (error) {});
  };

  sortingImages = (e) => {
    this.fetchImages(
      this.state.filter,
      this.state.initP,
      this.state.searchString
    );
  };

  handleScroll = () => {
    userID = this.props.userID;
    sessionID = this.props.sessionID;

    this.setState(
      {
        loader: true,
        elementID: this.props.ID,
        initP: this.state.initP + 1,
      },
      () => {
        Axios.MediaService.GET_IMAGES(
          userID,
          sessionID,
          this.state.filter,
          this.state.initP,
          this.state.searchString
        )
          .then((response) => {
            const data = response.data.body;
            if (response.data.statusCode === "success") {
              if (data.length == 12) {
                this.setState({
                  initialItems: [...this.state.initialItems, ...data],
                  loader: false,
                });
              }

              if (data.length < 12) {
                this.setState({
                  ...this.state,
                  loader: false,
                  noImageList: true,
                  initialItems: [...this.state.initialItems, ...data],
                });
              }
            }
          })
          .catch(function (error) {});
      }
    );
  };
  chooseImage = (image) => {
    this.props.forParentContent == true
      ? 
      this.setState(
          {
            ...this.state,
            chosenImage: {
              image_id: image.image_id,
              image_thumb: image.main_image,
              image_title: image.file_title,
            },
          },
         this.props.chooseImageForParent({
          image_id: image.image_id,
          image_thumb: image.main_image,
          image_title: image.file_title,
      })
        )
      : this.setState(
          {
            ...this.state,
            chosenImage: {
              image_id: image.image_id,
              image_thumb: image.main_image,
              image_title: image.file_title,
            },
          },
          this.pushImage({
            image_id: image.image_id,
            image_thumb: image.main_image,
            image_title: image.file_title,
          })
        );
  };
  render() {
    let fileContent = (
      <BottomScrollListener onBottom={this.handleScroll} offset={10}>
        {(scrollRef) => (
          <div className="videosWrapper" ref={scrollRef}>
            {this.state.initialItems.map((image, i) => {
              return (
                <div
                  key={i}
                  className={
                    "video-block " +
                    (this.state.chosenImage.image_id == image.image_id
                      ? " selectedImage"
                      : " ")
                  }
                  id={
                    this.state.chosenImage.image_id == image.image_id
                      ? "selectedImage"
                      : null
                  }
                  onClick={() => {
                    this.chooseImage(image);
                  }}
                >
                  <div className="imgWrapper file">
                    {" "}
                    <img
                      onError={(e) => {
                        e.target.src = noImage;
                      }}
                      src={image.thumb_image}
                    />
                  </div>
                  <p style={{ overflowX: "hidden" }}>
                    {image.file_title ? image.file_title : "Untitled"}
                  </p>
                </div>
              );
            })}

            {this.state.noImageList == true ? (
           
                <div
                  style={{
                    textAlign: "center",
                    width: "100%",
                    minWidth: "500px",
                    color: "#898989",
                    marginTop: "-15px",
                  }}
                  className="contentNote"
                >
                  No more content found...
                </div>
            
            ) : (
              ""
            )}
          </div>
        )}
      </BottomScrollListener>
    );
    return (
      <div>
        <div className="filtersWrapper">
          <div style={{ width: "100%" }} className="selectWrapper">
            {" "}
            <select
              defaultValue="d"
              className="sortOptions"
              onChange={(e) => {
                this.setState(
                  {
                    ...this.state,
                    initP: 0,
                    filter: e.target.value,
                  },
                  this.sortingImages
                );
              }}
            >
              <option value="d">Recently Uploaded</option>
              <option value="c">Chronologically</option>
              <option value="a">Alphabetically</option>
            </select>
          </div>
          <input
            type="text"
            //value={this.state.searchString}
            ref="search"
            onChange={this.handleChange}
            placeholder="Search"
            className="searchVideo"
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                this.fetchImages(
                  this.state.filter,
                  this.state.initP,
                  this.state.searchString
                );
              }
            }}
          />
          <button
            className="searchButton"
            onClick={() => {
              this.fetchImages(
                this.state.filter,
                this.state.initP,
                this.state.searchString
              );
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              xmlnsXlink="http://www.w3.org/1999/xlink"
              xmlns:svgjs="http://svgjs.com/svgjs"
              width={20}
              height={20}
              x={0}
              y={0}
              viewBox="0 0 612.01 612.01"
              style={{
                enableBackground: "new 0 0 512 512",
              }}
              xmlSpace="preserve"
            >
              <g>
                <g xmlns="http://www.w3.org/2000/svg">
                  <g id="_x34__4_">
                    <g>
                      <path
                        d="M606.209,578.714L448.198,423.228C489.576,378.272,515,318.817,515,253.393C514.98,113.439,399.704,0,257.493,0     C115.282,0,0.006,113.439,0.006,253.393s115.276,253.393,257.487,253.393c61.445,0,117.801-21.253,162.068-56.586     l158.624,156.099c7.729,7.614,20.277,7.614,28.006,0C613.938,598.686,613.938,586.328,606.209,578.714z M257.493,467.8     c-120.326,0-217.869-95.993-217.869-214.407S137.167,38.986,257.493,38.986c120.327,0,217.869,95.993,217.869,214.407     S377.82,467.8,257.493,467.8z"
                        fill="#0c3254"
                        data-original="#000000"
                        style={{}}
                        className=""
                      />
                    </g>
                  </g>
                </g>
                <g xmlns="http://www.w3.org/2000/svg" />
                <g xmlns="http://www.w3.org/2000/svg" />
                <g xmlns="http://www.w3.org/2000/svg" />
                <g xmlns="http://www.w3.org/2000/svg" />
                <g xmlns="http://www.w3.org/2000/svg" />
                <g xmlns="http://www.w3.org/2000/svg" />
                <g xmlns="http://www.w3.org/2000/svg" />
                <g xmlns="http://www.w3.org/2000/svg" />
                <g xmlns="http://www.w3.org/2000/svg" />
                <g xmlns="http://www.w3.org/2000/svg" />
                <g xmlns="http://www.w3.org/2000/svg" />
                <g xmlns="http://www.w3.org/2000/svg" />
                <g xmlns="http://www.w3.org/2000/svg" />
                <g xmlns="http://www.w3.org/2000/svg" />
                <g xmlns="http://www.w3.org/2000/svg" />
              </g>
            </svg>
          </button>
        </div>

        <div>
          <div style={{ position: "relative" }}>
            {fileContent}
            {this.state.loader && (
              <div
                className="positionStatusVideos"
                style={{ textAlign: "center", width: "100%" }}
              >
                <img
                  style={{ zIndex: "999999999", position: "relative" }}
                  src={Spinner}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    layout: state.present.layout,
    layoutTitle: state.present.layoutTitle,
    reloadAPI: state.present.reloadAPI,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    layoutArray: (titleValue, layoutVal) =>
      dispatch(
        actionTypes.layout({ titleLayout: titleValue, layout: layoutVal })
      ),
    reloadAPICall: (api) => dispatch(actionTypes.reload_api(api)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(ImagesContent);
